import React from 'react';
import logger from 'services/logger';
import {
  getURLWithUTMParameters,
  openWindow,
} from 'components/ShareDialog/utils';
import { ShareMethod } from './ShareMethod';
import { ShareMethodComponent } from './types';

export const ShareMethodWhatsApp: ShareMethodComponent = ({ url, onClick }) => {
  function handleClick(event: React.SyntheticEvent) {
    event.preventDefault();
    onClick();
    try {
      const shareUrl = encodeURIComponent(
        getURLWithUTMParameters(url, 'whatsapp')
      );
      openWindow(`https://wa.me/?text=${shareUrl}`);
    } catch (e) {
      logger.error(e, "Couldn't open WhatsApp share popup");
    }
  }

  return <ShareMethod label="WhatsApp" name="whatsapp" onClick={handleClick} />;
};
